export default __webpack_public_path__ + "static/media/newlogo.b646fa9e.png";